import React, { Fragment, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import dayjs from 'dayjs';

import './Rangebar.css';

function Rangebar(props: any) {
    const { rangetype, setRangetype, setTimeKeys, isMobile } = props;
    const { t } = useTranslation(undefined, { keyPrefix: 'Overview' });
    const [mobileOpen, setMobileOpen] = useState(false);

    const rangeOptions = useMemo(
        () => [
            { id: 'r1', label: t('currentWeek') },
            { id: 'r2', label: t('lastWeek') },
            { id: 'r3', label: t('currentMonth') },
            { id: 'r4', label: t('lastMonth') },
        ],
        [t]
    );

    const updateRange = (rangeId: any) => {
        setRangetype(rangeId);
        let now = dayjs();
        const timeOffset = now.utcOffset();
        now = now.subtract(timeOffset, 'minute');
        const day = now.day();
        let start_time = now.subtract((day + 6) % 7, 'day').startOf('day');
        let end_time = now.endOf('day');

        if (rangeId === 'r2') {
            start_time = start_time.subtract(7, 'day');
            end_time = start_time.add(6, 'day').endOf('day');
        } else if (rangeId === 'r3') {
            start_time = now.startOf('month');
            end_time = now.endOf('month');
        } else if (rangeId === 'r4') {
            start_time = now.subtract(1, 'month').startOf('month');
            end_time = now.subtract(1, 'month').endOf('month');
        }

        const keys = [];
        let start = start_time;
        while (start <= end_time) {
            keys.push(start.format('YYYY-MM-DD'));
            start = start.add(1, 'day');
        }
        setTimeKeys(keys);
    };

    const handleSelect = (rangeId: any) => {
        updateRange(rangeId);
        if (isMobile) {
            setMobileOpen(false);
        }
    };

    const activeLabel = useMemo(() => {
        const match = rangeOptions.find((option: any) => option.id === rangetype);
        return match ? match.label : t('currentWeek');
    }, [rangeOptions, rangetype, t]);

    useEffect(() => {
        if (!isMobile) {
            setMobileOpen(false);
        }
    }, [isMobile]);

    return (
        <div className={`rangebar${isMobile ? ' rangebar--mobile' : ''}`}>
            <div className='rangebar__container'>
                <div className='rangebar__container__title'>
                    <p>{t('range')}</p>
                </div>
                {rangeOptions.map((option: any, index: any) => (
                    <Fragment key={option.id}>
                        <div className='rangebar__container__item'>
                            <button
                                type='button'
                                className={rangetype === option.id ? 'active' : ''}
                                onClick={() => handleSelect(option.id)}
                            >
                                {option.label}
                            </button>
                        </div>
                        {index < rangeOptions.length - 1 && <div className='vline'></div>}
                    </Fragment>
                ))}
            </div>
            <div className='rangebar__mobile'>
                <button
                    type='button'
                    className={`rangebar__toggle${mobileOpen ? ' open' : ''}`}
                    onClick={() => setMobileOpen((prev: any) => !prev)}
                    aria-expanded={mobileOpen}
                    aria-haspopup='listbox'
                >
                    <span>{activeLabel}</span>
                    <span className='rangebar__chevron' aria-hidden='true' />
                </button>
                {mobileOpen && (
                    <div className='rangebar__mobile-options' role='listbox'>
                        {rangeOptions.map((option: any) => (
                            <button
                                key={option.id}
                                type='button'
                                className={`rangebar__option${rangetype === option.id ? ' active' : ''}`}
                                onClick={() => handleSelect(option.id)}
                                role='option'
                                aria-selected={rangetype === option.id}
                            >
                                {option.label}
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default Rangebar;
